import { brandConfig as immonetConfig } from './immonet';
import { brandConfig as immoweltConfig } from './immowelt';
import { brandConfig as immoweltatConfig } from './immoweltat';
import { brandConfig as logicimmoConfig } from './logicimmo';
import { brandConfig as selogerConfig } from './seloger';
import { brandConfig as selogerneufConfig } from './selogerneuf';
const brandsConfiguration = {
    immonet: immonetConfig,
    immowelt: immoweltConfig,
    immoweltat: immoweltatConfig,
    logicimmo: logicimmoConfig,
    seloger: selogerConfig,
    selogerneuf: selogerneufConfig,
};
export const useBrandConfiguration = ({ brand = 'immonet' }) => {
    const brandConfig = brandsConfiguration[brand];
    return {
        targeting: brandConfig?.targeting || { getTargeting: () => [], fetchHierarchy: false },
        brand: brandConfig?.brand || brand,
        headerBiddingScriptUrl: brandConfig?.headerBiddingScriptUrl || '',
        gptScriptUrl: brandConfig?.gptScriptUrl || '',
        adSlots: brandConfig?.adSlots || [],
        adSense: brandConfig?.adSense || {},
        googleTagManager: brandConfig?.googleTagManager || {},
    };
};
